import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ConfirmationService, MessageService, SharedModule } from 'primeng/api';
import { Subscription } from 'rxjs';
import { USER_MGMT_CNST, PROJECT_CONSTANTS } from '../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../constants/table.cnst';
// import { isNullOrUndefined, toDelay } from '../../modules/shared';
import { AppStateService } from '../../services/app-state.service';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';
import { EnvService } from '../../services/env.service';
import { HttpService } from '../../services/http.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { routes } from '../../../../../ap-crda-ui/src/app/app.routes';
import { SkeletonModule } from '../../modules/shared/components/skeleton/skeleton.module';
import { ImportsModule } from '../../modules/imports/imports';
import { TableModule } from 'primeng/table';
import { PrimengTableComponent } from '../../modules/shared/components/primeng-table/primeng-table.component';
import { PrimengBreadcrumbComponent } from '../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { AuthorizationModule } from '../../modules/authorization';
import { isNullOrUndefined, toDelay } from '../../shared/common-utils';
import { ButtonModule } from 'primeng/button';
import { TablerIconComponent } from 'angular-tabler-icons';
import { PermissionsService } from '../../modules/shared/directives/permissions.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  standalone: true,
  imports : [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AuthorizationModule,
    SkeletonModule,
    ImportsModule,
    ButtonModule,
    TableModule,
    CommonModule,
    PrimengTableComponent,
    PrimengBreadcrumbComponent,
    RouterModule,
    TablerIconComponent
  ]
})
export class CustomerComponent implements OnInit, OnDestroy {

  subscriptions : Subscription[] = [];
  tableConfig: any = {}
  tableData: any = [];
  tableDataCopy : any = [];
  isEditPermission: boolean = false;
  customerNamesWithIds : any[] = [];
  searchResultResponse : any = {};
  selectedCustomers : string[] = [];
  isSearchResultLoading : boolean = false;
  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  modalData: any = [];
  loading: boolean = true;
  isActiveList: boolean = true;
  customerRawList: any;
  

  constructor(
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private router: Router,
    private commonService: CommonService,
    private appStateSrv: AppStateService,
    private envService : EnvService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private permissionsService: PermissionsService
  ) { }

    

  ngOnInit() {
    this.initMethod()
    this.setTableConfig();
    this.setTableData();
    this.subscribeEvents();
  }

  initMethod() {
    this.isEditPermission = this.permissionsService.hasEditPermission(
      UM_TABLE_CNST.RESOURCES_LIST.customers,
      PROJECT_CONSTANTS.USERMGMT_APP_NAME
    );
  }

  subscribeEvents() {
    const operationRef = this.appStateSrv.operationRef.subscribe((value: any) => {
      let { operation, postData } = value;
      if (operation === USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.DELETE_CUSTOMER) {
        this.deleteCustomer(postData);
      } else {
        this.updateCustomer(postData);
      }
    });

    this.subscriptions.push(operationRef);
  }

  activateCustomer(customerInfo: any) {
    let { customerId } = customerInfo;

    let options = {
      'uriParams': { customerId }
    };

    this.httpSrv.makePutApiCall('ACTIVATE_CUSTOMER', {}, this.envService.baseUrl, options).subscribe({
      next: (response: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization activated successfully' });
        this.setTableData(); // Update the table data after activation
      },
      error: (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to activate organization" }); // Show error message
      }
    });
  }

  deActivateCustomer(customerInfo: any) {
    let { customerId } = customerInfo;

    let options = {
      'uriParams': { customerId }
    };

    this.httpSrv.makePutApiCall('DEACTIVATE_CUSTOMER', {}, this.envService.baseUrl, options).subscribe({
      next: (response: any) => {
        this.setTableData(); // Update the table data after deactivation
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization deactivated successfully' });
      },
      error: (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to deactivate organization" }); // Show error message
      }
    });
  }

  addCustomerPage(){
    if (!this.isEditPermission) {
      return;
    }
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    this.appStateSrv.setCustomerData({ operation: CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER, info: null });

    this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
      queryParams: {
        operation: CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER
      }
    });
  }

  async toggleTabs(isActive: boolean) {
    this.loading = true;
    this.isActiveList = isActive;
    this.setTableConfig();
    let customerList = Object.values(this.customerRawList);
    this.tableData = this.dataSrv.addOptionsToTableData(customerList, UM_TABLE_CNST.RESOURCES_LIST.customers);
    this.tableDataCopy = [...this.tableData];
    await toDelay(100);
    this.loading = false;
  }

  addCustomer(customerInfo: any) {
    let { name, purchasedPlan } = customerInfo;

    let postData = {
      meta : {
        customerName : name,
        purchasedPlan : purchasedPlan
      }
    };

    this.httpSrv.makePostApiCall('ADD_CUSTOMER', postData, this.envService.baseUrl).subscribe({
      next: (customerResponse: any) => {
        if (customerResponse.result) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization added successfully' });
          this.appStateSrv.setCurrentCustomerId(customerResponse.response); // Set the current customer ID
        }
      },
      error: (err: any) => {
        console.log("Failed to add customer", err); // Log the error
      }
    });
  }

  updateCustomer(customerInfo: any) {
    if (!this.isEditPermission) {
      return;
    }

    let { customerId } = customerInfo;
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    this.appStateSrv.setCustomerData({
      operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER,
      info: customerInfo
    });

    if (!isNullOrUndefined(customerId)) {

      this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
        queryParams: {
          operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER,
          customerId
        }
      });
    }
  }

  deleteCustomer(customerInfo: any) {
    if (!this.isEditPermission) {
      return;
    }
    let { customerId } = customerInfo;

    let options = {
      'uriParams': { customerId }
    };

    this.httpSrv.makeDeleteApiCall('DELETE_CUSTOMER', this.envService.baseUrl, options)
      .subscribe( {
        next: (response: any) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization deleted successfully' })
          this.setTableData();
        }, 
        complete: () => {},
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to delete the organization" })
          this.loading = false; 
        }
      })
  }

  setTableConfig() {
    this.tableConfig = this.commonService.setTableConfig(this.isActiveList?USER_MGMT_CNST.LIST_NAME_MAPPING.CUSTOMER_LIST: USER_MGMT_CNST.LIST_NAME_MAPPING.CUSTOMER_INACTIVE_LIST);
    console.log("tableConfig==", this.tableConfig)
  }

  setTableData() {
    console.log("this function called")
    this.loading = true;
    this.httpSrv.makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl).subscribe({
      next: (response: any) => {
        console.log("resppons=", response)
        this.customerRawList = response;
        let customerList = Object.values(response);
        this.tableData = this.dataSrv.addOptionsToTableData(customerList, UM_TABLE_CNST.RESOURCES_LIST.customers);
        console.log("tableData==", this.tableData), 
        this.tableDataCopy = [...this.tableData];
        this.loading = false;
      },
      complete: () => {},
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch organization list" })
        this.loading = false;
      }
    });
  }

  
  onCustomerNameEntered(event : any) {
    if (event.target.value.length >= 2 && this.selectedCustomers.length === 0) {
      this.loadSearchResultsByCustomerName(event.target.value);
    }
  }

  loadSearchResultsByCustomerName(searchQuery : string) {

    let options = {
      queryParams : {
        query : searchQuery
      }
    }

    this.isSearchResultLoading = true;

    this.httpSrv
    .makeGetApiCall('SEARCH_CUSTOMERS_BY_NAME', this.envService.baseUrl, options).subscribe({
      next: (searchResults: any) => {
        this.isSearchResultLoading = false; // Set loading state to false after receiving the response

        if (!isNullOrUndefined(searchResults.response)) { // Optional chaining to check if response exists
          this.searchResultResponse = searchResults.response;
          this.searchResultResponse = Object.values(searchResults.response); // Convert response object to an array
          this.customerNamesWithIds = this.dataSrv.formatCustomerNameSearchResponse(searchResults.response); // Format customer names
        }
      },
      error: (err: any) => {
        this.isSearchResultLoading = false; // Ensure loading state is false in case of an error
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch search results" }); // Show error message
        console.log("Error in fetching search results", err); // Log the error
      }
    });
  }

  onCustomerSelected() {

    //* If clear icon is clicked or backspace is pressed to clear the current selection
    //* then reset the already fetched items for the search query
    if (this.selectedCustomers.length === 0) {
      this.customerNamesWithIds = [];
      this.tableData = [...this.tableDataCopy];
    }
    //* Filter table records according to the selected customer
    else {
      let filteredTableRecords: any = this.dataSrv
        .filterCustomerTableRecordsForCustomerName(this.searchResultResponse, this.selectedCustomers);

      filteredTableRecords = this.dataSrv.addOptionsToTableData(filteredTableRecords, UM_TABLE_CNST.RESOURCES_LIST.customers);
      this.tableData = filteredTableRecords;
    }
  }

  handleOptionClick(rowData: any, operation: string) {
    if ((operation == USER_MGMT_CNST.OPTIONS.EDIT || operation == USER_MGMT_CNST.OPTIONS.DELETE) && !this.isEditPermission) {
      return;
    }
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;
    if (operation == USER_MGMT_CNST.OPTIONS.VIEW) {
      let postData = rowData;

      let { customerId } = postData;

      if (!isNullOrUndefined(customerId)) {
        this.appStateSrv.setCustomerData({ operation: CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER, info: postData });

        this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
          queryParams: {
            operation: CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER,
            customerId
          }
        });

      } else {
        console.log("Customer id is null or undefined");
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Organization id is missing" })
      }
    }

    else if (operation == USER_MGMT_CNST.OPTIONS.DELETE) {
      this.confirmationService.confirm({
        message: 'Do you want to delete this organization?',
        header: 'Confirmation',
       

        // rejectButtonStyleClass: "p-button-text",
        rejectButtonProps: {
          label: 'Cancel',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Delete',
          severity: 'danger',
          // size:'large'
        },

        accept: () => {
          this.deleteCustomer(rowData);
        },
        reject: () => {

        }
      });

 
    }

    else {
         let postData = rowData;
         this.setOperationType({operation: USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.EDIT_CUSTOMER,
        postData})
    }
  }
 

  setOperationType(value : any) {
    this.appStateSrv.operationRef.next(value);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription : Subscription) => subscription.unsubscribe());
  }

}
